import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applyPlayerQueries(message) {
    return applyRESTQueries(ConnectionNames.player, message);
}
//# sourceMappingURL=ApplyPlayerQueries.js.map